module.exports = __webpack_public_path__ + "static/media/eames-filter.4b75e4aa.jpeg";